var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.43 3.912 8.1 16.242l-4.53-4.53a.56.56 0 0 0-.796 0l-1.326 1.326a.563.563 0 0 0 0 .795l6.254 6.254c.22.22.576.22.796 0L22.552 6.034a.56.56 0 0 0 0-.796l-1.326-1.326a.56.56 0 0 0-.796 0"
  })));
};
export default SvgCheck;